import { apiDelete, apiPost, apiPut } from '@gat-ship/http-client'
import type {
  GetUserStateRequestParams,
  GetUserStateRequestResponse,
  RemoveUserStateItemRequestParams,
  SetUserStateRequestParams
} from '@gat-ship/types'

export function getMultipleItemsRequest<T extends string, U>(
  params: GetUserStateRequestParams
): Promise<GetUserStateRequestResponse<T, U>> {
  return apiPost('/user-state/batch-get', params.body, '')
}

export async function setItemRequest(
  params: SetUserStateRequestParams
): Promise<void> {
  await apiPut(`/user-state/items/${params.key}`, params.body, '', {
    params: params.queryParams
  })
}

export function removeItemRequest(
  params: RemoveUserStateItemRequestParams
): Promise<void> {
  return apiDelete(`/user-state/items/${params.key}`, '', '', {
    params: {
      storage_scope: params.queryParams.storage_scope
    }
  })
}
